(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.ForgotPasswordController = (function(superClass) {
    extend(ForgotPasswordController, superClass);

    function ForgotPasswordController(scope, transitions, modalInstance, http, location) {
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.http = http;
      this.location = location;
      this.save = bind(this.save, this);
      ForgotPasswordController.__super__.constructor.apply(this, arguments);
      this.scope.title = 'Reset Password';
      this.scope.user = {
        identifier: this.scope.params.email
      };
    }

    ForgotPasswordController.prototype.save = function() {
      var promise;
      promise = this.http.post('backend/session-mgmt/send-password-reset', {
        'identifier': this.scope.user.identifier,
        'b': this.location.search().b
      });
      return promise.then((function(_this) {
        return function(jsr) {
          return _this.closeWithAlert(jsr.data.status);
        };
      })(this));
    };

    return ForgotPasswordController;

  })(DialogController);

}).call(this);
